import React, { Component } from 'react'
import ScrollArea from 'react-scrollbar'

class BroadcastSchedule extends Component {


    render() {
        if (this.props.schedule.loading) return (<div><p style={{color: 'white', paddingLeft: '25px'}}>Loading...</p></div>);
        if (this.props.schedule.error) return 'Error fetch data';

        let schedules = JSON.parse(this.props.schedule.schedule);

        let schedulesElement = schedules.map((schedule, index) => (
                <li key={index}>
                    <a href="/">
                        <span className="time">{schedule.time}</span>
                        <span className="name">{schedule.title}</span>
                    </a>
                    {
                        schedule.sub ?
                        <div className="marquee">
                            <span>{schedule.sub}</span>
                        </div>
                        :
                        ''
                    }

                </li>
            ));

        return (
                <div className="main">
                    <ScrollArea style={{ position: "relative", overflow: "hidden", width: "auto", height: "450px" }}>
                        <div>
                            <ul className="list-unstyled">
                            {schedulesElement.length ?
                                schedulesElement
                                :
                                <p className="nothing-to-show">Chưa có lịch phát sóng</p>
                            }
                            </ul>
                        </div>
                    </ScrollArea>
                </div>
        );
    }
}

export default BroadcastSchedule



// WEBPACK FOOTER //
// ./src/components/LiveTV/BroadcastSchedule.js